/* Nove — theme interactions. Vanilla JS on the Shopify Cart AJAX API.
   Config comes from window.NOVE (set in theme.liquid). */
(function () {
  'use strict';
  var CFG = window.NOVE || {};
  var FREE_SHIP = CFG.freeShip || 5000; // cents
  var money = new Intl.NumberFormat(CFG.locale || 'de-DE', { style: 'currency', currency: CFG.currency || 'EUR' });
  var fmt = function (cents) { return money.format((cents || 0) / 100); };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------- Overlays (drawers + modal) a11y ---------------- */
  var lastFocus = null;
  function focusables(el) {
    return $$('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', el)
      .filter(function (n) { return n.offsetParent !== null; });
  }
  function trap(el, e) {
    if (e.key !== 'Tab') return;
    var f = focusables(el); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  var scrim = $('#scrim');
  var openOverlay = null;
  function openDrawer(el) {
    lastFocus = document.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    openOverlay = el;
    var f = focusables(el); if (f[0]) f[0].focus();
    el.addEventListener('keydown', keyHandler);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('is-open');
    document.body.style.overflow = '';
    el.removeEventListener('keydown', keyHandler);
    openOverlay = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function keyHandler(e) {
    if (e.key === 'Escape') { closeDrawer(openOverlay); }
    else if (openOverlay) { trap(openOverlay, e); }
  }
  if (scrim) scrim.addEventListener('click', function () { closeDrawer(openOverlay); });

  /* ---------------- Nav drawer ---------------- */
  var navDrawer = $('#nav-drawer');
  $$('[data-nav-open]').forEach(function (b) { b.addEventListener('click', function () { openDrawer(navDrawer); }); });
  $$('[data-nav-close]').forEach(function (b) { b.addEventListener('click', function () { closeDrawer(navDrawer); }); });

  /* ---------------- Cart drawer ---------------- */
  var cartDrawer = $('#cart-drawer');
  $$('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); openDrawer(cartDrawer); });
  });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', function () { closeDrawer(cartDrawer); }); });

  function renderCart(cart) {
    var count = cart.item_count;
    $$('[data-cart-count]').forEach(function (n) { n.textContent = count; n.hidden = count === 0; });
    var body = $('#cart-body'), foot = $('#cart-foot');
    if (!body) return;
    if (count === 0) {
      body.innerHTML = '<div class="cart-empty"><h3>Dein Warenkorb ist leer.</h3><p>Noch nichts dabei — schau dich in Ruhe um.</p></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    // free-ship
    var remaining = Math.max(0, FREE_SHIP - cart.total_price);
    var pct = Math.min(100, (cart.total_price / FREE_SHIP) * 100);
    var fsLabel = $('#freeship-label'), fsFill = $('#freeship-fill');
    if (fsLabel) fsLabel.textContent = remaining === 0
      ? 'Kostenfreier Versand — erreicht.'
      : 'Noch ' + fmt(remaining) + ' bis zum kostenfreien Versand.';
    if (fsFill) fsFill.style.width = pct + '%';
    // lines
    var html = cart.items.map(function (it, i) {
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '';
      var variant = (it.options_with_values || []).map(function (o) { return o.name + ': ' + o.value; }).join(' · ');
      if (variant === 'Title: Default Title') variant = '';
      return '<div class="cart-line" data-line="' + (i + 1) + '">' +
        '<div class="cart-line__media">' + img + '</div>' +
        '<div><div class="cart-line__name">' + esc(it.product_title) + '</div>' +
        (variant ? '<div class="cart-line__variant">' + esc(variant) + '</div>' : '<div class="cart-line__variant"></div>') +
        '<div class="qty" data-line-qty><button type="button" data-line-dec aria-label="Menge verringern">–</button>' +
        '<input type="number" min="0" value="' + it.quantity + '" aria-label="Menge" data-line-input>' +
        '<button type="button" data-line-inc aria-label="Menge erhöhen">+</button></div></div>' +
        '<div><div class="cart-line__price">' + fmt(it.final_line_price) + '</div>' +
        '<button type="button" class="cart-line__remove" data-line-remove>entfernen</button></div></div>';
    }).join('');
    body.innerHTML = html;
    var sub = $('#cart-subtotal'); if (sub) sub.textContent = fmt(cart.total_price);
    // wire line controls
    $$('.cart-line', body).forEach(function (row) {
      var line = row.getAttribute('data-line');
      var input = $('[data-line-input]', row);
      $('[data-line-dec]', row).addEventListener('click', function () { changeLine(line, Math.max(0, parseInt(input.value, 10) - 1)); });
      $('[data-line-inc]', row).addEventListener('click', function () { changeLine(line, parseInt(input.value, 10) + 1); });
      $('[data-line-remove]', row).addEventListener('click', function () { changeLine(line, 0); });
      input.addEventListener('change', function () { changeLine(line, Math.max(0, parseInt(input.value, 10) || 0)); });
    });
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function okJson(r) { if (!r.ok) { return r.json().then(function (e) { throw e; }); } return r.json(); }
  function cartError(err) { toast((err && (err.description || err.message)) || 'Etwas hat nicht geklappt. Bitte versuch es erneut.'); }
  function changeLine(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
    }).then(okJson).then(renderCart).catch(cartError);
  }
  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(okJson).then(function () {
      return getCart().then(function (cart) {
        renderCart(cart);
        openDrawer(cartDrawer);
        toast('In den Warenkorb gelegt.');
      });
    }).catch(cartError);
  }

  // PDP add-to-cart forms
  $$('form[data-atc-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]').value;
      var qtyEl = form.querySelector('[name="quantity"]');
      addToCart(id, qtyEl ? parseInt(qtyEl.value, 10) : 1);
    });
  });

  /* ---------------- Toast ---------------- */
  var toastEl = $('#toast'), toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.classList.add('is-open');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.classList.remove('is-open'); }, 2400);
  }

  /* ---------------- Qty stepper (PDP) ---------------- */
  $$('[data-qty]').forEach(function (q) {
    var input = $('input', q);
    $('[data-dec]', q).addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    $('[data-inc]', q).addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
  });

  /* ---------------- Gallery ---------------- */
  $$('[data-gallery]').forEach(function (g) {
    var slides = $$('[data-slide]', g), dots = $$('[data-dot]', g), i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.hidden = k !== i; });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    var prev = $('[data-prev]', g), next = $('[data-next]', g);
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
    show(0);
  });

  /* ---------------- Size-guide modal ---------------- */
  $$('[data-modal-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      var m = document.getElementById(b.getAttribute('data-modal-open'));
      if (!m) return;
      if (m.showModal) m.showModal(); else m.setAttribute('open', '');
    });
  });
  $$('dialog.modal').forEach(function (m) {
    $$('[data-modal-close]', m).forEach(function (c) { c.addEventListener('click', function () { m.close(); }); });
    m.addEventListener('click', function (e) { if (e.target === m) m.close(); });
  });

  /* ---------------- Sticky ATC ---------------- */
  var stickyAtc = $('#sticky-atc'), atcAnchor = $('#atc-anchor');
  if (stickyAtc && atcAnchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      stickyAtc.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(atcAnchor);
    $('.btn', stickyAtc) && $('.btn', stickyAtc).addEventListener('click', function () {
      var form = $('form[data-atc-form]'); if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  }

  /* ---------------- Variant picker (visual state) ---------------- */
  $$('[data-variants]').forEach(function (group) {
    var hidden = document.getElementById(group.getAttribute('data-variants'));
    $$('.variant', group).forEach(function (v) {
      v.addEventListener('click', function () {
        if (v.disabled) return;
        $$('.variant', group).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        v.setAttribute('aria-pressed', 'true');
        if (hidden && v.dataset.variantId) hidden.value = v.dataset.variantId;
      });
    });
  });

  /* ---------------- Consent (visual + basic state; real gating = CMP app) ---------------- */
  var consent = $('#consent');
  if (consent) {
    if (!localStorage.getItem('nove-consent')) { consent.hidden = false; }
    function setConsent(v) { localStorage.setItem('nove-consent', v); consent.hidden = true; }
    var acc = $('[data-consent-accept]', consent), rej = $('[data-consent-reject]', consent);
    if (acc) acc.addEventListener('click', function () { setConsent('all'); });
    if (rej) rej.addEventListener('click', function () { setConsent('essential'); });
  }

  /* ---------------- Newsletter / contact (inline success) ---------------- */
  $$('form[data-ajax-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (form.getAttribute('data-demo') === 'true') {
        e.preventDefault();
        var ok = form.querySelector('[data-form-success]');
        if (ok) { ok.hidden = false; form.querySelector('[data-form-fields]') && (form.querySelector('[data-form-fields]').hidden = true); }
      }
    });
  });

  // initial cart sync
  getCart().then(renderCart).catch(function () {});
})();
